import { useEffect, useRef, useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { CircleNotch, CheckCircle, WarningCircle } from "@phosphor-icons/react";

export default function MagicVerify() {
  const [sp] = useSearchParams();
  const nav = useNavigate();
  const { magicVerify } = useAuth();
  const [state, setState] = useState("verifying"); // verifying | ok | error
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const token = sp.get("token");
    if (!token) { setState("error"); return; }
    magicVerify(token, false)
      .then(() => { setState("ok"); setTimeout(() => nav("/dashboard", { replace: true }), 900); })
      .catch(() => setState("error"));
  }, [sp, magicVerify, nav]);

  return (
    <main className="grid min-h-[70vh] place-items-center px-5" data-testid="magic-verify">
      <div className="w-full max-w-sm rounded-2xl border border-border/60 bg-card p-8 text-center shadow-sm">
        {state === "verifying" && (
          <>
            <CircleNotch size={34} className="mx-auto animate-spin text-primary" />
            <h1 className="mt-4 font-heading text-2xl">Signing you in…</h1>
            <p className="mt-2 text-sm text-muted-foreground">Verifying your secure link.</p>
          </>
        )}
        {state === "ok" && (
          <>
            <CheckCircle size={34} weight="fill" className="mx-auto text-emerald-600" />
            <h1 className="mt-4 font-heading text-2xl">Welcome back!</h1>
            <p className="mt-2 text-sm text-muted-foreground">Taking you to your dashboard…</p>
          </>
        )}
        {state === "error" && (
          <>
            <WarningCircle size={34} weight="fill" className="mx-auto text-amber-600" />
            <h1 className="mt-4 font-heading text-2xl">Link expired or invalid</h1>
            <p className="mt-2 text-sm text-muted-foreground">Magic links work once and expire after 15 minutes.</p>
            <Link to="/login" className="mt-5 inline-block rounded-full bg-primary px-5 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90" data-testid="magic-retry">Request a new link</Link>
          </>
        )}
      </div>
    </main>
  );
}
